import React, { PropsWithChildren, ReactNode } from 'react';
import { Fieldset as PrimeFieldset, FieldsetPassThroughOptions } from 'primereact/fieldset';
import { Info } from './Info';
import { getHelp } from '../../../../util/intl.utils';
import { IntlShape, useIntl } from 'react-intl';

interface Props {
  className?: string;
  toggleable?: boolean;
  pt?: FieldsetPassThroughOptions;
}

interface PropsFieldset extends Props {
  title?: string;
}

export const Fieldset = (props: PropsWithChildren<PropsFieldset>): ReactNode => {
  const intl: IntlShape = useIntl();
  return (
    <InnerFieldset
      legend={props.title ? intl.formatMessage({id: `${props.title}.label`}) : undefined}
      info={props.title ? `${props.title}.help` : undefined}
      className={props.className}
      toggleable={props.toggleable}
      pt={props.pt}
    >
      {props.children}
    </InnerFieldset>
  );
};

interface PropsPersonName extends Props {
  legend: ReactNode;
  info?: string;
}

export const FieldsetPersonName = (props: PropsWithChildren<PropsPersonName>): ReactNode => {
  return (
    <InnerFieldset
      legend={props.legend}
      info={props.info}
      className={props.className}
      toggleable={props.toggleable}
      pt={props.pt}
    >
      {props.children}
    </InnerFieldset>
  );
};

interface InnerProps extends Props {
  legend?: ReactNode;
  info?: string;
}

const InnerFieldset = (props: PropsWithChildren<InnerProps>): ReactNode => {
  const intl: IntlShape = useIntl();
  const pt = {...(props.pt || {}), legend: {...props.pt?.legend || {className: ''}}};
  const help: string = props.info ? getHelp(intl, props.info) : null;
  return (
    <PrimeFieldset
      legend={props.legend}
      className={props.className}
      toggleable={props.toggleable}
      pt={{...pt, content: {className: 'flex flex-column gap-4 p-0 pt-4'}}}
    >
      {help && <Info info={help}/>}
      {props.children}
    </PrimeFieldset>
  );
};
